import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
    
      <Helmet>
 
 <title>Learn Free JavaScript If Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript if tutorial for beginners if in Javascript is used for making a decision.If and else can be a block statement ,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript if,Javascript if for,Javascript if,Javascript if for loop,if foreach Javascript,Javascript foreach if" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-if" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">if statement in Javascript</h1>
    <div className="first">
        <a href="/javascript-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
<p className="mt-4 para">If statement use for making a decision. If and else can be a block statement
</p>



<h2 className="headings">If Syntax in Javascript:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        

  {"\n"}
  <span className="qwerty-10">if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  

  {"\n"}
  {"\n"}
</code>
      </pre>        
    </div>




<h2 className="headings">Q-Write a program to input a number and check this number is more than or equal to 100 If Statement in JavaScript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">102; </span>
          {"\n"}

    <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#62;=</span> 
        <span className="qwerty-1">100</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-10">"This no is greater than 100"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}





<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"} 
          <span className="qwerty-3">This no is greater than 100 </span>          
          {"\n"}
          
            </code>{"   "}
            </pre>
      </div>
    </div>

<h3 className="mt-4 mh3">IF Statement in Javascript with multiple conditions and Check <a href="https://www.codeexampler.com/javascript-if-else">if else in javascript</a></h3>



<h2 className="headings">Q-Write a program to input a number and print greater no If Statement in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty-8">=</span>
            <span className="qwerty-1">160208; </span>
          {"\n"}

    <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-1">500</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-3">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"This " </span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">+</span>
        <span className="qwerty-10">" no is Smaller than 500"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}

  {"\n"}
    <span className="qwerty-5">&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#62;</span> 
        <span className="qwerty-1">500</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-1">"This " </span>
        <span className="qwerty-8">+</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">+</span>
        <span className="qwerty-10">" no is Greater than 500"</span> 
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}





<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;This </span>             
          <span className="qwerty-5">160208 </span>  
          <span className="qwerty-3">no is Greater than </span>   
          <span className="qwerty-5">500 </span>         
          {"\n"}
          
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
       
  <div className="back">
        <a href="/javascript-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csif;